document.addEventListener('DOMContentLoaded', () => {
  const textArea = document.querySelector('.tco-input--expand textarea');

  if ( !textArea ) {
    return;
  }

  // remove rows so expanding text js from ui lib can do it's thing
  textArea.removeAttribute('rows');
})